<template>
  <MainLayout>
    <div class="parallax"
         data-parallax
         data-parallax-speed="0.25"
         data-parallax-direction="down">
      <div class="relative w-screen ">
        <img class="absolute -left-[1vw] top-[-0vh] w-[20vw] opacity-80" src="/images/bg-visual-left-top.webp" alt="">
        <img class="absolute -right-[6vw] top-[18vh] w-[30vw] opacity-60" src="/images/bg-visual-right-top.webp" alt="">
      </div>
    </div>

    <section id="hero">
      <div class="flex items-center lg:mt-[3rem] lg:mb-[2rem]">
        <div class="flex flex-col gap-y-4.5 lg:gap-y-8">
          <h1 class="text-[32px] leading-[36px] lg:text-[70px] lg:leading-[74px]  font-bold text-dark text-center font-markPro lg:max-w-[20ch] tracking-[-0.1rem]">
            {{ t('pages.home.hero.heading.serve') }}
            <span class="text-gradient-primary whitespace-nowrap">{{ t('pages.home.hero.heading.more_orders') }}</span>
            {{ t('pages.home.hero.heading.to_your_restaurant') }}
          </h1>

          <div class="flex flex-col text-center leading-[27px] lg:text-lg font-semibold">
            <p class="text-lighter">{{ t('pages.home.hero.saving_time') }}</p>
            <p class="text-dark">{{ t('pages.home.hero.boosting_business') }}</p>
          </div>
        </div>
      </div>

      <div class="w-full  grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-8 lg:gap-4">

        <div class="p-4 lg:px-6 lg:py-8 flex flex-col gap-y-8 justify-between h-full bg-white rounded-xl drop-shadow-lg"
             v-for="(plan, key, index) in tm('pages.pricing.plans')">
          <div class="flex flex-col gap-y-0 lg:gap-y-1">
            <h4 class="font-markPro text-gradient-primary text-[26px] font-bold tracking-[-0.03rem]">
              {{ plan.title }}
            </h4>

            <div class="flex items-center gap-x-4 min-h-[56px]">
              <h5 class="font-markPro font-bold tracking-[-0.1rem]"
                  :class="{ 'text-[30px]': index == 3, 'text-[40px]': index != 3 }">{{ plan.price }}</h5>
              <span class="text-lighter text-[17px] pt-[6px]">{{ plan.period }}</span>
            </div>

            <p class="text-lighter pt-[0.2rem]">{{ plan.subtitle }}</p>

            <p class="font-semibold pt-[1.5rem] pb-[1rem]">{{ plan.description }}</p>

            <ul>
              <li v-for="feature in plan.enabledFeatures"
                  class="flex items-center gap-x-2 text-lighter text-[15px] leading-[32px]">
                <img src="/images/ico-check.svg"/>
                <span>{{ feature }}</span>
              </li>

              <li v-for="feature in plan.disabledFeatures" class="flex items-center gap-x-2 text-lighter">
                <i class="bi bi-x text-lighter text-3xl"></i>
                <span class="text-lighter">{{ feature }}</span>
              </li>

            </ul>
          </div>

          <div class="flex flex-col gap-y-8 justify-center items-center">
            <a v-if="index == 3"
               href="https://webforms.pipedrive.com/f/6k1fJdz7xgA49xFsdiLKDuoJ6y0vj7QgYFKhNOo8Gf4SEA7lu5dJ0YDBJRJ67NCUn1"
               class="btn btn-lg text-[15px] btn-primary text-center whitespace-nowrap !w-full ">{{ plan.start }}
            </a>
            <a v-if="index !== 3"
               v-track-event="'onboarding_start'"
               href="https://merchant.bistroo.nl/register"
               class="btn btn-lg text-[15px] btn-primary text-center whitespace-nowrap !w-full ">{{ plan.start }}
            </a>
            <a href="#" class="text-gradient-primary font-semibold text-xs">{{ t('pages.pricing.compare') }}</a>
          </div>
        </div>

      </div>

    </section>

    <section id="overview">
      <div class="flex flex-col gap-y-8 items-center">

        <div class="flex flex-col gap-y-4.5 lg:gap-y-10">
          <h1 class="text-[26px] leading-[36px] lg:text-5xl font-bold text-dark text-center font-markPro">
            {{ t('pages.pricing.closer_look.title') }}
          </h1>

          <div class="flex flex-col text-center">
            <p class="font-semibold lg:text-lg text-lighter">{{ t('pages.pricing.closer_look.description.1') }}</p>
            <p class="font-semibold lg:text-lg text-dark">{{ t('pages.pricing.closer_look.description.2') }}</p>
          </div>
        </div>
      </div>

      <div class="relative w-screen lg:w-auto">

        <div id="pricing-table-container" class="w-full overflow-x-scroll scrollbar-hide">
          <div class="pricing-table">
            <div class="row header">
              <h4 class=""></h4>
              <span class="text-gradient-primary">Gratis</span>
              <span class="text-gradient-primary">Starter</span>
              <span class="text-gradient-primary">Professional</span>
              <span class="text-gradient-primary">Enterprise</span>
            </div>

            <div class="lg:border lg:border-[#EEE] lg:rounded-xl lg:overflow-hidden">

              <div class="row">
                <h4>Producten</h4>
                <span>Webshop of website</span>
                <span>Webshop of QR</span>
                <span>Website & webshop</span>
                <span>Website, webshop & QR</span>
              </div>

              <div class="row">
                <h4>Maandelijkse fee</h4>
                <span>&euro; 0</span>
                <span>&euro; 39</span>
                <span>&euro; 49</span>
                <span>Custom</span>
              </div>

              <div class="row">
                <h4>Commissie fee</h4>
                <span>7%</span>
                <span>-</span>
                <span>-</span>
                <span>-</span>
              </div>

              <div class="row">
                <h4>Opstartkosten</h4>
                <span>&euro; 0</span>
                <span>&euro; 0</span>
                <span>&euro; 0</span>
                <span>Custom</span>
              </div>

              <div class="row">
                <h4>Gratis proefperiode</h4>
                <span>30 dagen</span>
                <span>30 dagen</span>
                <span>30 dagen</span>
                <span>30 dagen</span>
              </div>

              <!--<div class="row">
                <h4>Transactiekosten</h4>
                <span>&euro; 0,29</span>
                <span>&euro; 0,29</span>
                <span>&euro; 0,29</span>
                <span>&euro; 0,29</span>
              </div>-->

              <div class="row">
                <h4>Manager</h4>
                <span>Basis opties</span>
                <span>Geavanceerde opties</span>
                <span>Premium opties</span>
                <span>Full premium opties</span>
              </div>
              <div class="row">
                <h4>Order management</h4>

                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
              </div>

              <div class="row">
                <h4>Sales insights</h4>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
              </div>

              <div class="row">
                <h4>Menu builder</h4>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
              </div>

              <div class="row">
                <h4>Product configurator</h4>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
              </div>

              <div class="row">
                <h4>Kortingen & promoties</h4>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
              </div>

              <div class="row">
                <h4>Advanced reporting</h4>
                <span></span>
                <span>3 reports</span>
                <span>ongelimiteerd</span>
                <span>ongelimiteerd</span>
              </div>

              <div class="row">
                <h4>Integraties (POS etc.)</h4>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
              </div>

              <div class="row">
                <h4>Printer support</h4>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
              </div>

              <div class="row">
                <h4>Custom branding</h4>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
              </div>

              <div class="row">
                <h4>Website</h4>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
              </div>

              <div class="row">
                <h4>Marktplaats (optioneel)</h4>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
              </div>

              <div class="row">
                <h4>Gebruikersbeheer</h4>
                <span></span>
                <span></span>
                <span>2 gebruikers</span>
                <span>ongelimiteerd</span>
              </div>

              <div class="row">
                <h4>Klantenservice</h4>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span><i class="bi bi-check text-gradient-primary text-2xl"></i></span>
                <span>Account manager</span>
              </div>

              <div class="row">
                <h4>Social media promo’s</h4>
                <span></span>
                <span></span>
                <span></span>
                <span>Inclusief</span>
              </div>
            </div>
          </div>
        </div>

        <Transition>
          <div v-if="showSwipeToShowMore"
               class="flex lg:hidden absolute bottom-4 right-4 backdrop-blur backdrop-brightness-90 text-lighter px-4 py-2 rounded-full items-center gap-x-2">
            Swipe to see more
            <i class="bi bi-arrow-right"></i>
          </div>
        </Transition>
      </div>

    </section>

    <section id="cta" class="backgroundgradient backgroundgradient-bottom">
      <div class="w-full rounded-2xl py-16 max-md:px-14 lg:pt-26 lg:pb-20 relative overflow-hidden">

        <div class="absolute inset-0 z-10 bg-[#E3EEF7]"></div>
        <div class="parallax "
             data-parallax
             data-parallax-speed="0.05"
             data-parallax-direction="down">

          <div class="relative w-full h-full">
            <img class="absolute top-0 left-0 -translate-x-1/3 h-[150%] rotate-[45%]"
                 src="/images/bg-visual-left-top.webp"
                 alt="">

            <img class="absolute right-0 translate-x-1/3 -top-1/4 lg:-top-1/2 h-1/2 lg:h-full rotate-[-20deg]"
                 src="/images/bg-visual-right-top.webp"
                 alt="">
          </div>
        </div>

        <div class="flex flex-col gap-y-5.5 justify-center items-center text-center relative z-30">
          <h4 class="text-[32px] leading-[42px] lg:text-5xl font-bold text-dark text-center font-markPro block tracking-[-0.08rem]">
            Open your webshop today.
            <span class="text-gradient-primary whitespace-nowrap"> It's free!</span>
          </h4>

          <p class="text-lg lg:text-[24px] text-lighter font-semibold">Start generating more orders within minutes</p>

          <a v-track-event="'onboarding_start'"
             href="https://merchant.bistroo.nl/register"
             class="btn btn-lg btn-primary flex items-center gap-x-3 mt-4">
            <span>Get started free</span>
            <i class="bi bi-arrow-right text-lg mt-[3px]"></i>
          </a>
        </div>
      </div>

    </section>
  </MainLayout>
</template>

<script setup lang="ts">

import MainLayout from '@/layouts/MainLayout.vue'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const {t, tm} = useI18n()

const showSwipeToShowMore = ref<boolean>(true)

onMounted(() => {
  const pricingTableContainer = document.querySelector('#pricing-table-container')

  if (!(pricingTableContainer instanceof HTMLDivElement)) {
    console.warn('Could not retrieve pricingTableContainer')
    return
  }

  pricingTableContainer.addEventListener('scroll', (e: Event) => {
    if (pricingTableContainer.scrollLeft > 150) {
      showSwipeToShowMore.value = false
    }
  })
})

</script>

<style scoped>
@reference "@/assets/css/main.css";

.pricing-table {
  @apply w-max lg:w-auto grid;

  .row:not(.header) {
    &:nth-child(odd) {
      @apply bg-white;

      h4 {
        @apply bg-white;
      }
    }

    &:nth-child(even) {
      @apply bg-body;

      h4 {
        @apply bg-body;
      }
    }
  }

  .row {
    grid-template-columns: 35vw 1fr 1fr 1fr 1fr; /* Tailwind template col definitions are unreadable */
    @apply grid lg:grid-cols-5 pe-2 text-end gap-x-6 lg:text-center text-lighter transition-all ;

    font-size:             15px;

    &.header {
      @apply shadow shadow-light pb-[0.5rem] bg-body;

      span {
        @apply font-semibold font-markPro text-[26px];
      }

      h4 {
        @apply bg-body;
      }
    }

    h4, span {
      @apply p-4;
    }

    h4 {
      @apply sticky left-0 border-r border-zinc-200 lg:border-none z-20  font-semibold text-start text-dark ;
    }

    span {
      @apply z-10 min-w-fit whitespace-nowrap last:pe-8;
    }
  }
}
</style>